import { QuotationClientReviewCreate } from './../components/business/quotation/quotation-client-review-create.component';
import { Injectable } from '@angular/core';
import { ServiceVisitEditPopupComponent } from '@shared/components/business/service-visit/service-visit-edit/service-visit-edit-popup.component';
import { MatDialog } from '@angular/material';
import { NoteEditPopupComponent } from '@shared/components/business/note/note-edit/note-edit-popup.component';
import { DocumentEditPopupComponent } from '@shared/components/business/document/document-edit/document-edit-popup.component';
import { InvoiceItemCreatePopupComponent } from '@shared/components/business/invoice/invoice-item-create/invoice-item-create-popup.component';
import { ServiceEditPopupComponent } from '@shared/components/business/service/service-edit/service-edit-popup.component';
import { QuotationItemCreatePopupComponent } from '@shared/components/business/quotation/quotation-item-create/quotation-item-create-popup.component';
import { PurchaseOrderItemCreatePopupComponent } from '@shared/components/business/purchase-order/purchase-order-item-create/purchase-order-item-create-popup.component';
import { InvoiceItemEditPopupComponent } from '@shared/components/business/invoice/invoice-item-edit/invoice-item-edit-popup.component';
import { QuotationItemEditPopupComponent } from '@shared/components/business/quotation/quotation-item-edit/quotation-item-edit-popup.component';
import { PurchaseOrderItemEditPopupComponent } from '@shared/components/business/purchase-order/purchase-order-item-edit/purchase-order-item-edit-popup.component';
import { AssetCreatePopupComponent } from '@shared/components/business/asset/asset-create/asset-create-popup.component';
import { BuildingEditPopupComponent } from '@shared/components/business/building/building-edit/building-edit-popup.component';
import { ServiceVisitCreatePopupComponent } from '@shared/components/business/service-visit/service-visit-create/service-visit-create-popup.component';
import { PurchaseOrderEditPopupComponent } from '@shared/components/business/purchase-order/purchase-order-edit/purchase-order-edit-popup.component';
import { QuotationEditPopupComponent } from '@shared/components/business/quotation/quotation-edit/quotation-edit-popup.component';
import { PurchaseOrderCreatePopupComponent } from '@shared/components/business/purchase-order/purchase-order-create/purchase-order-create-popup.component';
import { ServiceCreatePopupComponent } from '../components/business/service/service-create/service-create-popup.component';
import { HolidayCreateComponent } from '../components/business/holiday/holiday-create/holiday-create.component';
import { HolidayEditComponent } from '../components/business/holiday/holiday-edit/holiday-edit.component';
import { HolidayApprovalComponent } from '../components/business/holiday/holiday-approval/holiday-approval.component';
import { VatCalculatePopupComponent } from '../components/common/vat-calculate-popup/vat-calculate-popup.component';

@Injectable()
export class PopupService {
  constructor(
    public dialog: MatDialog,
  ) {
  }

  openCreateServiceVisitPopup({ item, rateType }) {
    return this.dialog.open(ServiceVisitCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { item: item, rateType }
    });
  }

  openServiceVisitEditPage(visit_id, service) {
    return this.dialog.open(ServiceVisitEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: visit_id, service: service }
    });
  }

  openNoteEditPage(note_id) {
    return this.dialog.open(NoteEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: note_id }
    });
  }

  openDocumentEditPage(document_id) {
    return this.dialog.open(DocumentEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: document_id }
    });
  }

  openInvoiceItemCreatePage(invoice_id) {
    return this.dialog.open(InvoiceItemCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: invoice_id }
    });
  }

  openServiceEditPage(service_id) {
    return this.dialog.open(ServiceEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: service_id }
    });
  }

  openServiceCreatePage(data) {
    return this.dialog.open(ServiceCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { service_type: data.service_type }
    });
  }

  openBuildingEditPage(buildingId) {
    return this.dialog.open(BuildingEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: buildingId }
    });
  }

  openPurchaseOrderCreatePopup({ serviceId, clientId }) {
    return this.dialog.open(PurchaseOrderCreatePopupComponent, {
      width: '80%',
      disableClose: true,
      data: { serviceId, clientId }
    });
  }

  openQuotationItemCreatePage(quotation_id, services) {
    return this.dialog.open(QuotationItemCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: quotation_id, services }
    });
  }

  openPurchaseOrderItemCreatePage(purchase_order_id, services) {
    return this.dialog.open(PurchaseOrderItemCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: purchase_order_id, services }
    });
  }

  openInvoiceItemEditPage(invoice_item_id) {
    return this.dialog.open(InvoiceItemEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: invoice_item_id }
    });
  }

  openQuotationEditPage(quotationId) {
    return this.dialog.open(QuotationEditPopupComponent, {
      width: '80%',
      disableClose: true,
      data: { id: quotationId }
    });
  }

  openPurchaseOrderEditPage(purchaseOrderId) {
    return this.dialog.open(PurchaseOrderEditPopupComponent, {
      width: '80%',
      disableClose: true,
      data: { id: purchaseOrderId }
    });
  }

  openQuotationItemEditPage(quotation_item_id) {
    return this.dialog.open(QuotationItemEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: quotation_item_id }
    });
  }

  openVatCalculatePopup(subtotal, vat) {
    return this.dialog.open(VatCalculatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { subtotal: subtotal, vat: vat }
    });
  }

  openPurchaseOrderItemEditPage(purchase_order_item_id) {
    return this.dialog.open(PurchaseOrderItemEditPopupComponent, {
      width: '80%',
      disableClose: false,
      data: { id: purchase_order_item_id }
    });
  }

  openAssetCreatePage(companyId, buildingId) {
    return this.dialog.open(AssetCreatePopupComponent, {
      width: '80%',
      disableClose: false,
      data: { companyId, buildingId }
    });
  }

  openQuotationClientReview(clientId, mode = 'user') {
    return this.dialog.open(QuotationClientReviewCreate, {
      disableClose: false,
      data: { clientId: clientId, mode: mode }
    });
  }

  openHolidayCreatePopup(user_id) {
    return this.dialog.open(HolidayCreateComponent, {
      disableClose: false,
      data: { user_id: user_id }
    });
  }

  openHolidayUpdatePopup(id) {
    return this.dialog.open(HolidayEditComponent, {
      disableClose: false,
      data: { id: id }
    });
  }

  openHolidayApprovalPopup(id) {
    return this.dialog.open(HolidayApprovalComponent, {
      disableClose: false,
      data: { id: id }
    });
  }
}
